export interface SpamNumberFormState {
    id?: number | null;
    number: string | null;
}
